<template>
	<v-dialog v-model="value" max-width="65%" scrollable @click:outside="$emit('input', false)">
		<v-card>
			<v-card-title class="title primary--text mb-2 secondary" v-translate>Recommendations</v-card-title>
			<v-progress-linear
				:active="loadingRecommendations"
				:indeterminate="loadingRecommendations"
				top
				color="primary"
			></v-progress-linear>
			<v-card-text v-if="!loadingRecommendations">
				<template v-if="recommended_points.length == 0">
					<p class="grey--text mb-3" v-translate>No Points to recommend.</p>
				</template>
				<template v-else>
					<v-progress-linear v-model="coverage" height="25" reactive class="white--text" rounded>
						<strong>{{ Math.ceil(coverage) }}%</strong>
					</v-progress-linear>
					<p v-if="selectedPoints.length == 0" class="grey--text my-3" v-translate>No Points selected.</p>
					<v-list v-else flat>
						<v-list-item-group>
							<v-list-item
								v-for="point in selectedPoints"
								:key="point.id"
								style="border: 1px solid #e0e0e0; border-radius: 5px"
								@click="selectRecomendation(point)"
							>
								<v-list-item-icon class="mr-3">
									<v-icon color="primary">$vuetify.icons.acuIcon</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										<strong>{{name(point)}}</strong>
									</v-list-item-title>
									<v-list-item-subtitle>{{side(point)}}</v-list-item-subtitle>
								</v-list-item-content>
								<v-list-item-action>
									<v-row no-gutters align="center">
										<v-checkbox v-model="point.selected" color="primary"></v-checkbox>
									</v-row>
								</v-list-item-action>
							</v-list-item>
						</v-list-item-group>
					</v-list>
					<v-divider></v-divider>
					<p v-if="pointsToRecommend.length == 0" class="grey--text my-3" v-translate>No more points to recommend.</p>
					<v-list v-else flat>
						<v-list-item-group>
							<v-list-item
								v-for="point in pointsToRecommend"
								:key="point.id"
								style="border: 1px solid #e0e0e0; border-radius: 5px"
								@click="selectRecomendation(point)"
							>
								<v-list-item-icon class="mr-3">
									<v-icon color="primary">$vuetify.icons.acuIcon</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										<strong>{{name(point)}}</strong>
									</v-list-item-title>
									<v-list-item-subtitle>{{side(point)}}</v-list-item-subtitle>
								</v-list-item-content>
								<v-list-item-action>
									<v-row no-gutters align="center">
										<span class="primary--text font-weight-bold mr-3">+{{point.percentage}}%</span>
										<v-checkbox v-model="point.selected" color="primary"></v-checkbox>
									</v-row>
								</v-list-item-action>
							</v-list-item>
						</v-list-item-group>
					</v-list>
					<template v-if="ryodoraku_results.length > 0">
						<p class="mt-4 text-subtitle-1 font-weight-medium" v-translate>Ryodoraku Results</p>
						<v-row no-gutters>
							<v-col v-for="result in ryodoraku_results" cols="6" :key="result.id">
								<v-row no-gutters align="center">
									<v-col cols="12">
										<span class="mx-1 font-weight-bold" v-for="(channel, i) in result.channels" :key="i + channel.channel">
											{{channel.channel.name}} - {{channel.quality.name}}
										</span>
									</v-col>
									<v-col v-if="result.note" cols="12">
										<span class="mx-1">{{result.note}}</span>
									</v-col>
									<v-col cols="12">
										<v-row no-gutters align="center" class="ml-2">
											<p v-if="result.points.length == 0" class="grey--text my-3" v-translate>No recommendations.</p>
											<v-col v-else cols="12">
											<v-list flat>
												<v-list-item-group>
													<v-list-item
														v-for="point in result.points"
														:key="point.id"
														style="border: 1px solid #e0e0e0; border-radius: 5px"
														@click="selectRecomendation(point)"
													>
														<v-list-item-icon class="mr-3">
															<v-icon color="primary">$vuetify.icons.acuIcon</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title>
																<strong>{{name(point)}}</strong>
															</v-list-item-title>
															<v-list-item-subtitle>{{side(point)}}</v-list-item-subtitle>
														</v-list-item-content>
														<v-list-item-action>
															<v-row no-gutters align="center">
																<!-- <span class="primary--text font-weight-bold mr-3">+{{point.percentage}}%</span> -->
																<v-checkbox v-model="point.selected" color="primary"></v-checkbox>
															</v-row>
														</v-list-item-action>
													</v-list-item>
												</v-list-item-group>
											</v-list>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</template>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn v-if="selectedPoints.length > 0 || selectedRyodorakuPoints.length > 0" color="primary" @click="addPoints">
					<translate>Add</translate>
				</v-btn>
				<v-btn color="primary darken-1" text @click="hide">
					<translate>Close</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios";

export default {
	name: "AcupunctureRecommendations",
	props: ["value"],
	data: () => ({
		loadingRecommendations: true,
		coverage: 0,
		recommended_points: [],
		diagnosis_icd: [],
		points_indications: [],
		diagnosis_icd_selected: [],
		ryodoraku_results:[]
	}),
	computed: {
		selectedPoints() {
			return this.recommended_points.filter(point => point.selected);
		},
		selectedRyodorakuPoints() {
			let points = [];
			for(let i=0; i < this.ryodoraku_results.length; i++) {
				for (let h=0; h < this.ryodoraku_results[i].points.length; h++) {
					if(this.ryodoraku_results[i].points[h].selected) points.push(this.ryodoraku_results[i].points[h]);
				}
			}
			return points;
		},
		pointsToRecommend() {
			return this.recommended_points
				.filter(point => !point.selected)
				.sort(this.comparePercentage);
		}
	},
	methods: {
		hide() {
			this.$emit("hide-recommendations");
		},
		comparePercentage(point1, point2) {
			return point2.percentage - point1.percentage;
		},
		selectRecomendation(point) {
			point.selected = !point.selected;
			this.updatePercentages();
		},
		addPoints() {
			this.$emit("add-recommendations", this.selectedPoints.concat(this.selectedRyodorakuPoints));
			this.hide();
		},
		name(point) {
			let strs = point.name.split("-");
			let channel = strs[0];
			if(channel == 'LU') return this.$gettext('LU') + "-" + strs[1];
			if(channel == 'PC') return this.$gettext('PC') + "-" + strs[1];
			if(channel == 'HE') return this.$gettext('HE') + "-" + strs[1];
			if(channel == 'SI') return this.$gettext('SI') + "-" + strs[1];
			if(channel == 'SJ') return this.$gettext('SJ') + "-" + strs[1];
			if(channel == 'LI') return this.$gettext('LI') + "-" + strs[1];
			if(channel == 'SP') return this.$gettext('SP') + "-" + strs[1];
			if(channel == 'LIV') return this.$gettext('LIV') + "-" + strs[1];
			if(channel == 'KD') return this.$gettext('KD') + "-" + strs[1];
			if(channel == 'BL') return this.$gettext('BL') + "-" + strs[1];
			if(channel == 'GB') return this.$gettext('GB') + "-" + strs[1];
			if(channel == 'ST') return this.$gettext('ST') + "-" + strs[1];
			if(channel == 'REN') return this.$gettext('REN') + "-" + strs[1];
			if(channel == 'DU') return this.$gettext('DU') + "-" + strs[1];
			if(channel == 'EX') return this.$gettext('EX') + "-" + strs[1];
			if(channel == 'ASHI') return "ASHI" + "-" + strs[1];
			return point.name;
		},
		side(point) {
			if (point.side === "left") return this.$gettext("Left");
			else if (point.side === "right") return this.$gettext("Right");
			else return this.$gettext("Center");
		},
		updatePercentages() {
			this.diagnosis_icd_selected = [];
			this.selectedPoints.forEach(point => {
				var icds = this.points_indications[point.id];
				icds.forEach(icd => {
					if (this.diagnosis_icd && !this.diagnosis_icd_selected.includes(icd)) {
						this.diagnosis_icd_selected.push(icd);
					}
				});
			});

			var missing_codes = this.diagnosis_icd.filter(item => !this.diagnosis_icd_selected.includes(item));
			var num_missing_codes = missing_codes.length;
			var percentage = (num_missing_codes * 100) / this.diagnosis_icd.length;
			percentage = Math.round(percentage);
			this.coverage = 100 - percentage;

			this.pointsToRecommend.forEach(point => {
				var icds = this.points_indications[point.id];

				var missing_covered = [];
				icds.forEach(function(icd) {
					if (missing_codes.includes(icd) && !missing_covered.includes(icd)) {
						missing_covered.push(icd);
					}
				});
				if (missing_codes.length > 0) {
					var percentage = (missing_covered.length * 100) / missing_codes.length;
					percentage = Math.round(percentage);
					point.percentage = percentage;
				} else {
					//hide percentage
				}
			});
		},
		getRecommendations() {
			const appointmentId = this.$route.params.aid;
			const patientId = this.$route.params.pid;
			axios
				.get(
					"/patient/" +
						patientId +
						"/appointment/" +
						appointmentId +
						"/recommended_acu_points"
				)
				.then(response => {
					if (response.status === 200) {
						console.log(response.data);
						var points = response.data.acu_points;
						points.forEach(point => {
							point.selected = false;
							point.percentage = 0;
						});
						this.recommended_points = points;
						this.diagnosis_icd = response.data.diagnosis;
						this.points_indications = response.data.acu_points_indications;
						let ryo_results = response.data.ryodoraku_results;
						ryo_results.forEach(r => {
							r.points.forEach(p => {
								p.selected = false;
							});
						});
						this.ryodoraku_results = response.data.ryodoraku_results;
						this.loadingRecommendations = false;
						this.updatePercentages();
					}
				})
				.catch(error => {
					console.log(error);
					this.loadingRecommendations = false;
				});
		}
	},
	watch: {
		value(value) {
			if (value == true) {
				this.loadingRecommendations = true;
				this.getRecommendations();
			}
		}
	}
};
</script>